import { APP_NAME } from "@constants/app.constants";
import ManufacturerCreateComponent from "@screens/inventory/inventory-manufacturer/manufacturer-create/manufacturer-create.component";
import ManufacturerListComponent from "@screens/inventory/inventory-manufacturer/manufacturer-list/manufacturer-list.component";
import ManufacturerEditComponent from "@screens/inventory/inventory-manufacturer/manufacturer-edit/manufacturer-edit.component";

const inventoryManufacturersRoutes = [
  {
    name: `Inventory Manufacturers - ${APP_NAME}`,
    path: "/inventory/manufacturers",
    icon: "layout",
    component: ManufacturerListComponent,
  },
  {
    name: `Create Inventory Manufacturers - ${APP_NAME}`,
    path: "/inventory/manufacturers/create",
    component: ManufacturerCreateComponent,
  },
  {
    name: `Edit Inventory Manufacturers- ${APP_NAME}`,
    path: "/inventory/manufacturers/edit",
    component: ManufacturerEditComponent,
  },

];

export default inventoryManufacturersRoutes;
